import type { ListeningItem } from '../types';
import { coursePlanLessons } from './coursePlan';

const leadIns = {
  Beginner: 'Listen and repeat:',
  A1: 'Listen to the short sentence:',
  A2: 'Listen to the situation:',
  B1: 'Listen for the main idea:',
  B2: 'Listen for stance and evidence:',
  C1: 'Listen for nuance and qualification:',
} as const;

export const listeningItems: ListeningItem[] = coursePlanLessons.map((lesson) => {
  const text = `${leadIns[lesson.level]} ${lesson.example.en}`;
  const words = lesson.example.en.replace(/[.,!?]/g, '').split(' ');
  return {
    id: `l-${lesson.id}`,
    level: lesson.level,
    category: lesson.category,
    text,
    russian: lesson.example.ru,
    question: lesson.level === 'Beginner' || lesson.level === 'A1' ? 'Повтори фразу и проверь русский смысл.' : 'Repeat the phrase, then explain the speaker purpose.',
    answer: lesson.example.ru,
    missingWord: words[Math.min(2, words.length - 1)] ?? words[0] ?? '',
    speedSuggestion: lesson.level === 'Beginner' || lesson.level === 'A1' ? 'slow' : lesson.level === 'A2' || lesson.level === 'B1' ? 'careful' : 'normal',
  };
});
